import withFormikWrapper from '../formik/withFormikWrapper';
import CleanRadioGroup from '../cleanRadioGroup';

export const CleanFormikRadioGroup = withFormikWrapper()(CleanRadioGroup);
